/** Joins class names, skipping falsy parts. Deliberately tiny: no dependency, no Tailwind merging. */
export function cn(...parts: Array<string | false | null | undefined>): string {
  return parts.filter(Boolean).join(' ');
}
